import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isInvalidPassword(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) {
    return null;
  }
  const lengthValid = control.value.length >= 12;

  if (!lengthValid) {
    return { isInvalidPasswordLength: true };
  }

  const hasAlphanumericCharacters = !!control.value.match(/[a-zA-Z0-9]/);

  if (!hasAlphanumericCharacters) {
    return { isPasswordMissingAlphanumericCharacters: true };
  }

  const hasSpecialCharacters = !!control.value.match(/[^a-zA-Z0-9]/);

  if (!hasSpecialCharacters) {
    return { isPasswordMissingSpecialCharacters: true };
  }

  return null;
}
